"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = require("../index");

var _index2 = _interopRequireDefault(_index);

var _accounts = require("../../accounts");

var _accounts2 = _interopRequireDefault(_accounts);

var _registrations = require("../../registrations");

var _registrations2 = _interopRequireDefault(_registrations);

var _payments = require("../../payments");

var _payments2 = _interopRequireDefault(_payments);

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = angular.module('ifeis.printing.parentcards', ['ifeis.payments']).factory('fPrintParentCards', function ($q, fFeisService, fPaymentsService, fRegistrationService, fAccountService, fPrint) {
  var _this = this;

  var orderRegistrations = function orderRegistrations(regs) {
    var eventsNameSorting = ['Reel', 'Light Jig', 'Slip Jig', 'Single Jig', 'Treble Jig', 'Hornpipe'];

    var grades = regs.filter(function (r) {
      return eventsNameSorting.indexOf(r.event.event) > -1;
    }).sort(function (a, b) {
      return eventsNameSorting.indexOf(a.event.event) - eventsNameSorting.indexOf(b.event.event);
    });
    var figures = regs.filter(function (r) {
      return r.event.type === 'F';
    });
    var specials = regs.filter(function (r) {
      return r.event.type === 'S';
    });
    var others = regs.filter(function (r) {
      return eventsNameSorting.indexOf(r.event.event) < 0 && r.event.type !== 'F' && r.event.type !== 'S';
    });

    return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(grades ? grades : []), _toConsumableArray(figures ? figures : []), _toConsumableArray(specials ? specials : []), _toConsumableArray(others ? others : [])))));
  };

  var print = function print(pages, feisName, star) {
    return fPrint.getStarIcon().then(function (star) {
      return _this.star = star;
    }).then(function () {
      return fPrint.getTasksIcon();
    }).then(function (tasks) {
      return _this.tasks = tasks;
    }).then(function () {

      var bulletPoints = ["Schedule and Competition Status updated live on your Dashboard", "Click on blue icon        to view the live schedule", "When Competition is in Results status, select the Competition to see Placings", "Click on Feis in Recent Results to see Placings and Comments, when available"];

      function drawFront(person, quad, params, doc) {
        doc.fontSize(params.headlineSize + 20).font('Helvetica');

        doc.text("Feis Day!", quad.x, quad.y, {
          width: params.qWidth,
          height: params.qHeight,
          align: 'center',
          underline: true
        });

        doc.fontSize(params.textSize).font('Helvetica');
        doc.list(bulletPoints, quad.x, quad.y + 70, {
          width: params.qWidth,
          height: params.qHeight,
          align: 'left',
          lineGap: 5
        });

        //add the star icon to the pdf
        doc.image(this.tasks, quad.x + 115, quad.y + 105, { width: 15 });

        // add the blue tasks icon to the pdf
        //doc.image(this.tasks, quad.x + 187, quad.y + 143, { width: 15 });

        doc.font('Helvetica-Oblique');

        doc.text("www.iFeis.net — The future of feising is here", quad.x, quad.y + params.pageHeight / 2 - params.margin * 2, {
          width: params.qWidth,
          height: params.qHeight,
          align: 'center'
        });
      }
      (0, _common.createCompetitorInfoCards)(fPrint, drawFront.bind(_this), pages, feisName, 'parent-cards.pdf');
    });
  };

  var printCards = function printCards(fid) {
    var regSvc = fRegistrationService.for(fid);
    // fetch all registrations for feis
    return regSvc.all().then(function (reg) {
      // sort by last name, first name without case sensitivity
      reg.sort(function (a, b) {
        return a.lname.localeCompare(b.lname, 'en', { 'sensitivity': 'base' }) || a.fname.localeCompare(b.fname, 'en', { 'sensitivity': 'base' });
      });
      // Order registrations
      var orderedReg = reg.map(function (c) {
        return _extends({}, c, {
          registrations: orderRegistrations(c.registrations)
        });
      });
      // Combine this into an array of arrays, with 4 competitors per subarray (to match pagination).
      var tmpArray = [];
      return orderedReg.reduce(function (coll, c, idx, arr) {
        tmpArray.push(c);
        if (tmpArray.length >= 4 || arr.length - 1 === idx) {
          coll.push(tmpArray);
          tmpArray = [];
        }
        return coll;
      }, []);
    }).then(function (pages) {
      fFeisService.one(fid).then(function (feis) {
        return print(pages, feis.name);
      });
    });
  };

  return printCards;
});


//////////////////
// WEBPACK FOOTER
// ./print/parent-cards/index.js
// module id = 491
// module chunks = 0